angular.module('ActionManager', ['ResourceGenerator', 'ngLodash', 'sod-logger']);